/* eslint-disable react-hooks/exhaustive-deps */
import { MessageTypeEnum } from 'Modules/Communication/shared/models/Recipients'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getActiveClient } from 'shared/store/clients/selectors'
import {
  fetchFrequentEmailRecipientsRequest,
  fetchFrequentSmsRecipientsRequest,
} from 'shared/store/sendMessage/recipients'
import { getFrequentRecipients } from 'shared/store/sendMessage/recipients/selectors'

const useInitFrequentRecipients = (type: MessageTypeEnum) => {
  const dispatch = useDispatch()
  const client = useSelector(getActiveClient)
  const {
    sms,
    email,
    fetchedEmailWithClientId,
    fetchedSmsWithClientId,
  } = useSelector(getFrequentRecipients)

  // Checks clientId, this counts as a "fetched" state,
  // Triggers a fetch if user has swapped client,
  // And avoids refetching if user has not swapped client

  // Initial Email
  useEffect(() => {
    if (
      type === MessageTypeEnum.Email &&
      client?.id === fetchedEmailWithClientId &&
      email.data?.length
    )
      return
    if (
      type === MessageTypeEnum.Email &&
      client?.id !== fetchedEmailWithClientId
    ) {
      dispatch(fetchFrequentEmailRecipientsRequest())
    }
  }, [])

  // Initial SMS
  useEffect(() => {
    if (
      type === MessageTypeEnum.SMS &&
      client?.id === fetchedSmsWithClientId &&
      sms.data?.length
    )
      return
    if (type === MessageTypeEnum.SMS && client?.id !== fetchedSmsWithClientId) {
      dispatch(fetchFrequentSmsRecipientsRequest())
    }
  }, [])
}

export default useInitFrequentRecipients
